import axios from 'axios';
import {
    START_LOADING_AXIOS,
    FINISH_LOADING_AXIOS,
    ERROR_LOADING_AXIOS
 } from './../../../constants/openLoop/validation/index';

export const setStartLoading = () => (dispatch) => {
    dispatch({
        type: START_LOADING_AXIOS
    });
};

export const setFinishLoading = () => (dispatch) => {
    dispatch({type: FINISH_LOADING_AXIOS});
};

export const setErrorLoading = (payload) => (dispatch) => {
    dispatch({type: ERROR_LOADING_AXIOS, payload});
};


export const getStatus = (queryString) => (dispatch) => {
    try {
        dispatch({type: START_LOADING_AXIOS, queryString});
        axios({
            url: `/get/status/openloop-validation-checks?check=${queryString}`,
            method: 'GET'
        }).then((response) => {
            console.log("Validation Response", response);
            if(response && response.status === 200) {
                const { data } = response;
                dispatch({type: FINISH_LOADING_AXIOS, queryString, info: data['ping'] });
            } else {
                console.log("else", response);
                const errorMsg = response['data']['message'] || 'Error occurred while fetching this request!';
                dispatch({type: ERROR_LOADING_AXIOS, queryString, payload: errorMsg});
            }
        }).catch(error => {
            console.error('Axios Error', error);
            const errorMsg = 'Error occurred while fetching this request!';
            dispatch({type: ERROR_LOADING_AXIOS, queryString, payload: errorMsg});
        })
    } catch(error) {
        console.error(error);
        const errorMsg = error.message || 'Error occurred while fetching this request!';
        dispatch({type: ERROR_LOADING_AXIOS, queryString, payload: errorMsg});
    }
};


export const getScenarioGroupStatus = (topologyId) => (dispatch) => {
    try {
        dispatch({type: START_LOADING_AXIOS, queryString: topologyId});
        axios({
            url: `/get/status/cm-security-groups/openloop-validation-checks?cad_topology_job_uuid=${topologyId}`,
            method: 'GET'
        }).then((response) => {
            console.log("Scenario Group Response", response);
            if(response && response.status === 200) {
                const { data } = response;
                console.log(response);
                dispatch({type: FINISH_LOADING_AXIOS, queryString: topologyId, info: data['info'] });
            } else {
                console.log("else", response);
                const errorMsg = response['data']['message'] || 'Error occurred while fetching this request!';
                dispatch({type: ERROR_LOADING_AXIOS, queryString: topologyId, payload: errorMsg});
            }
        }).catch(error => {
            console.error('Axios Error', error);
            const errorMsg = error.response.data.message || 'Error occurred while fetching this request!';
            dispatch({type: ERROR_LOADING_AXIOS, queryString: topologyId, payload: errorMsg});
        })
    } catch(error) {
        console.error(error);
        const errorMsg = error.message || 'Error occurred while fetching this request!';
        dispatch({type: ERROR_LOADING_AXIOS, queryString: topologyId, payload: errorMsg});
    }
};